/*
 *
 * SettingsAlertPopup
 *
 * @version 1.0.0
 * @author Ivana Piscitelli
 * @since 24-Apr-2025
*/

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import SettingsAlertPopup from './SettingsAlertPopup'
import { doHidePopup, doShowPopup } from 'Store/actions/popup'
import { doGetAlertsStatus, doPutAlertsStatus } from 'Route/Profile/modules/ProfileActions'
import { nullSafe } from 'Utility/globalMethods'

const mapDispatchToProps = dispatch => ({
  ...bindActionCreators({ doShowPopup, doHidePopup, doGetAlertsStatus, doPutAlertsStatus }, dispatch)
})

const mapStateToProps = state => ({
  alertsStatus: nullSafe(() => state.Profile.alertsStatus, {}),
  isLoading: nullSafe(() => state.loading.localLoading.get_history, false),
  hasReportPermission: Boolean(nullSafe(() => state.userProfiling.menuItemsData.REPORT, null)),
  alertFeatures: nullSafe(() => state.userProfiling.profileItemsData.SETTINGS.prop.alertFeatures, undefined)
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(SettingsAlertPopup)
